import customerSvc from '../services/vueCustomerSvc'; 

export default {
  asyncComputed: {
    closestColorBar: {
      lazy: true,
      get() {
        return this.$http.get('/api/colorbar/getColorBarNewClientOffers', {
          params: {}
        }).then(res => res.data);
      }
    }
  },

  methods: {
    writeReview(url, rating) {
      var href = `/product/${url}/review`;
      if (rating !== undefined) {
        href += `?stars=${rating}`;
      }

      window.location.href = href;
    },

    getPaginatedPurchaseHistory(page, size, callback) {
      customerSvc.getPaginatedPurchaseHistory(page, size).then(res => {
        callback(res.data);
      }).catch(() => {
        callback([]);
      });
    }
  }
};
